//@ts-check

import styled from '@emotion/styled';
import { Tabs } from 'antd';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getThemeColor } from 'store/settings';

/**
 * @param {import('antd').TabsProps & {children: (props: {TabPane: React.FC<import('antd').TabPaneProps> }) => React.ReactNode, tabCss?: string }} props
 * @returns {JSX.Element}
 */

const AntdTab = ({ tabCss, children, ...props }) => {
  const themeColor = useSelector(getThemeColor);

  const TabStyle = useMemo(
    () => styled(Tabs)`
      .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
        color: ${themeColor};
        text-shadow: 0 0 0.25px currentcolor;
      }

      .ant-tabs-ink-bar {
        position: absolute;
        background: ${themeColor};
        pointer-events: none;
      }

      .ant-tabs-tab-btn:focus,
      .ant-tabs-tab-remove:focus,
      .ant-tabs-tab-btn:active,
      .ant-tabs-tab-remove:active {
        color: ${themeColor};
      }

      .ant-tabs-tab:hover {
        color: ${themeColor};
      }
      ${tabCss}
    `,
    [themeColor, tabCss],
  );

  return <TabStyle {...props}>{children({ TabPane: Tabs.TabPane })}</TabStyle>;
};

export default AntdTab;
